/* TODO LIST
- Loading state
*/

const PROMO_TILE_SIZES =
  '(min-width: 750px) calc((100vw - 1rem) / 4), calc((100vw - 1rem) / 2)';

const prefersReducedMotion = window.matchMedia(
  '(prefers-reduced-motion: reduce)'
).matches;

function buildPromoTileSrcset(imageUrl) {
  if (!imageUrl) {
    return '';
  }
  return `${imageUrl}&width=180 180w, ${imageUrl}&width=360 360w, ${imageUrl}&width=540 540w, ${imageUrl}&width=720 720w, ${imageUrl}&width=900 900w, ${imageUrl}&width=1080 1080w`;
}

function createPromoTileImage({ src, width, height, className }) {
  const tileImage = document.createElement('img');
  tileImage.classList.add('motion-reduce');
  if (className) {
    tileImage.classList.add(className);
  }
  tileImage.loading = 'lazy';
  tileImage.width = width;
  tileImage.height = height;
  tileImage.src = src;
  tileImage.srcset = buildPromoTileSrcset(src);
  tileImage.sizes = PROMO_TILE_SIZES;
  tileImage.alt = '';
  return tileImage;
}

function createPromoTileVideo({ src, poster, width, height, className }) {
  const tileVideo = document.createElement('video');
  tileVideo.classList.add('promo-loop-video');
  if (className) {
    tileVideo.classList.add(className);
  }
  tileVideo.src = src;
  if (poster) {
    tileVideo.poster = poster;
  }
  tileVideo.width = width;
  tileVideo.height = height;
  tileVideo.muted = true;
  tileVideo.loop = true;
  tileVideo.playsInline = true;
  tileVideo.setAttribute('muted', '');
  tileVideo.setAttribute('playsinline', '');
  tileVideo.setAttribute('webkit-playsinline', '');
  tileVideo.autoplay = false;
  tileVideo.controls = false;
  tileVideo.preload = 'none';
  tileVideo.setAttribute('aria-hidden', 'true');
  return tileVideo;
}

function observePromoLoopVideos(root) {
  if (!('IntersectionObserver' in window) || prefersReducedMotion) {
    return;
  }

  if (!root._promoVideoObserver) {
    root._promoVideoObserver = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          const video = entry.target;
          if (entry.isIntersecting) {
            const playPromise = video.play();
            if (playPromise && typeof playPromise.catch === 'function') {
              playPromise.catch(() => {});
            }
          } else {
            video.pause();
          }
        });
      },
      { rootMargin: '100px 0px', threshold: 0.25 }
    );
  }

  root
    .querySelectorAll('video.promo-loop-video:not([data-observed])')
    .forEach((video) => {
      video.dataset.observed = 'true';
      root._promoVideoObserver.observe(video);
    });
}

/**
 * Use algoliaShopify for all product relateed data, including:
 * - Filters
 * - Sorting
 * - Pagination
 */
class ListingAlgolia extends HTMLElement {
  constructor() {
    super();

    // Component data
    this.loaded = false;
    this.indexAdjust = 0;
    this.collectionHandle = this.dataset.collectionHandle;
    this.collectionId = this.dataset.collectionId;
    this.sectionId = this.dataset.sectionId;
    this.searchTerms = this.dataset.searchTerms || '';
    this.queryId = '';

    this.init();  
  }

  init() {
     const collectionPromoScript = document.getElementById('ColectionPromos');
    if (collectionPromoScript) {
      try {
        this.collectionPromos = JSON.parse(collectionPromoScript.textContent);
      } catch (error) {
        console.error('Failed to parse ColectionPromos JSON', error);
        this.collectionPromos = null;
      }
    }    

    // Algolia search client
    this.searchClient = window['algoliasearch/lite'].liteClient(
      algoliaShopify.config.app_id,
      algoliaShopify.config.search_api_key,
      {
        baseHeaders: {
          'X-Algolia-UserToken': getAlgoliaUserToken(),
        },
      }
    );

    // Initial state
    const collectionQueryRuleValue = algoliaShopify.config
      .collection_id_query_rules
      ? this.collectionId
      : this.collectionHandle;

    this.analyticsTags = [
      collectionQueryRuleValue,
      'collection',
      getDeviceType(),
    ];

    this.hitsPerPage =
      algoliaShopify.config.products_full_results_hits_per_page;
    this.currentPage = 0;

    this.currentSortBy = '';
    this.currentFilters = {};

    this.sortData =
      algoliaShopify.config.collection_sort_orders &&
      algoliaShopify.config.collection_sort_orders[this.collectionId]
        ? algoliaShopify.config.collection_sort_orders[this.collectionId]
        : algoliaShopify.config.sort_orders;

    this.facetData =
      algoliaShopify.config.collection_facets &&
      algoliaShopify.config.collection_facets[this.collectionId]
        ? algoliaShopify.config.collection_facets[this.collectionId]
        : algoliaShopify.config.facets;
    this.facetFilters = [];

    this.facetData.forEach((facet) => {
      if (facet.enabled) {
        this.facetFilters.push(facet.name);
      }
    });

    this.setStatesFromURL();

    // DOM elements
    this.pillsContainer = document.querySelector('#AlgoliaFilterPills');
    this.itemCounts = document.querySelectorAll('.AlgoliaItemCount');
    this.sortBy = document.querySelector('#AlgoliaSortBy');
    this.sortByDrawer = document.querySelector('#AlgoliaDrawerSortBy');
    this.filtersDesktop = document.querySelector('#AlgoliaDesktopFilters');
    this.filtersDrawer = document.querySelector('#AlgoliaDrawerFilters');
    this.productList = document.querySelector('#AlgoliaProductGrid');
    this.paginationContainer = document.querySelector('#AlgoliaPagination');

    // Events
    this.debouncedOnSubmit = debounce((event) => {
      this.onFilterChange(event);
    }, 800);

    if (this.filtersDesktop) {
      this.filtersDesktop.addEventListener(
        'input',
        this.debouncedOnSubmit.bind(this)
      );
    }

    if (this.filtersDrawer) {
      this.filtersDrawer.addEventListener(
        'input',
        this.debouncedOnSubmit.bind(this)
      );
    }

    if (this.sortBy) {
      this.generateSortFromConfig();
      this.sortBy.addEventListener('change', this.onSortChange.bind(this));
      this.sortByDrawer.addEventListener(
        'change',
        this.onSortChange.bind(this)
      );
    }

    if (this.paginationContainer) {
      this.paginationContainer
        .querySelector('.pagination__select')
        .addEventListener('change', this.onPaginationSelect.bind(this));

      this.paginationContainer
        .querySelector('.pagination__button--prev')
        .addEventListener('click', this.onPaginationPrev.bind(this));

      this.paginationContainer
        .querySelector('.pagination__button--next')
        .addEventListener('click', this.onPaginationNext.bind(this));
    }

    window.addEventListener('popstate', (event) => {
      this.currentFilters = event.state ? event.state.searchParams : {};
      this.currentSortBy = event.state ? event.state.sortBy : '';
      this.currentPage = event.state ? event.state.page : 0;

      this.setDOMStates();
      this.search();
    });

    // Initial search. We require consent tracking to be loaded first.
    window.Shopify.loadFeatures(
      [
        {
          name: 'consent-tracking-api',
          version: '0.1',
        },
      ],
      this.search.bind(this, true)
    );
  }

  disconnectedCallback() {
    if (this.onAlgoliaLoadedUnsubscriber) {
      this.onAlgoliaLoadedUnsubscriber();
    }

    if (this.onSwatchChangeUnsubscriber) {
      this.onSwatchChangeUnsubscriber();
    }
  }

  connectedCallback() {
    // If its a collection, send an Algolia Viewed Event
    this.onAlgoliaLoadedUnsubscriber = subscribe(
      PUB_SUB_EVENTS.algoliaLoaded,
      () => {
        if (this.collectionHandle) {
          window.Shopify.loadFeatures(
            [
              {
                name: 'consent-tracking-api',
                version: '0.1',
              },
            ],
            () => {
              aa('viewedFilters', {
                userToken: getAlgoliaUserToken(),
                index: this.buildIndexParams(),
                eventName: 'Landing Page Viewed',
                filters: [`collections:${this.collectionHandle}`],
              });
            }
          );
        }
      }
    );

    this.onSwatchChangeUnsubscriber = subscribe(
      PUB_SUB_EVENTS.swatchChange,
      (target) => {
        aa('viewedObjectIDs', {
          userToken: getAlgoliaUserToken(),
          eventName: 'Product Viewed',
          index: this.buildIndexParams(),
          objectIDs: [String(target.dataset.variantId)],
        });
      }
    );
  }

  /**
   * Set the current parameters from the URL.
   * Only needs to do filters and sorting since those are the only
   * parameters that are not handled by the algoliaShopify API.
   */
  setStatesFromURL() {
    const urlParams = new URLSearchParams(window.location.search);

    urlParams.forEach((value, key) => {
      if (key == 'page') {
        this.currentPage = parseInt(value);
      } else if (key == 'sort_by') {
        this.currentSortBy = value;
      } else if (this.facetFilters.includes(key)) {
        if (!this.currentFilters[key]) {
          this.currentFilters[key] = [];
        }

        this.currentFilters[key].push(value);
      }
    });
  }

  /**
   * Set the DOM states from the current parameters.
   */
  setDOMStates() {
    this.sortBy.value = this.currentSortBy;
    this.sortByDrawer.querySelectorAll('input').forEach((input) => {
      if (input.value == this.currentSortBy) {
        input.checked = true;
      } else {
        input.checked = false;
      }
    });

    Object.keys(this.currentFilters).forEach((filter) => {
      this.currentFilters[filter].forEach((value) => {
        if (this.filtersDesktop) {
          const filterElement = this.filtersDesktop.querySelector(
            `input[name="${filter}"][value="${value}"]`
          );

          if (filterElement) {
            filterElement.checked = true;
          }
        }

        if (this.filtersDrawer) {
          const filterElement = this.filtersDrawer.querySelector(
            `input[name="${filter}"][value="${value}"]`
          );

          if (filterElement) {
            filterElement.checked = true;
          }
        }
      });
    });
  }

  /**
   * Reset the product list.
   */
  resetProductList() {
    this.indexAdjust = 0;
    this.currentPage = 0;
    this.productList.innerHTML = '';
  }

  /**
   * Search algoliaShopify for the product data.
   * @param {boolean} fullBuild - Whether to fully rebuild the product list and filters. It'll only be false when a filter or sort is applied.
   */
  search(fullBuild = true, paginationTriggered = false) {
    this.cleanEmptyFilters();
    if (fullBuild && this.loaded) {
      this.resetProductList();
    }

    /**
     * This is used to build the search params for the algoliaShopify API.
     *
     * We need to send multiple requests in one search because in algolia, facet data is conjunctive.
     * Meaning, naturally, you can't apply multiple filters to the same facet.
     *
     * So, we need to build a query for each facet that is applied.
     *
     * For example, if you have a filter for color and a filter for size, you need to build two queries in addition to the default query.
     *
     * The first query will be the default query, which includes the color and size facetFilters.
     * The second query will be the query will only include the color facetFilters.
     * The third query will be the query will only include the size facetFilters.
     *
     * The first query will then be used to build the product list and the pagination, since this is the "true" query
     * that the customer is wanting to see.
     *
     * For all facets that are not applied (lets say: 'type'), the first query will ALSO be used. Since we want to
     * only show the filters that can actually be applied with the current filters.
     *
     * The second and third queries will be used to build their respective filters. The way it works is that
     * the facetFilters that are applied to the query include all filters except those in the same group.
     *
     * So for query 2, the facetFilters will be the color facetFilters, but not the size facetFilters.
     * Meaning that it will return all size filters, that can be applied with the current color filters.
     *
     * The same goes for query 3.
     *
     * IF there are no filters applied, the first query will be used to build ALL the filters.
     */

    const queryParams = this.buildMultipleSearchParams();

    this.searchClient.search({ requests: queryParams }).then((queries) => {
      if (paginationTriggered) {
        this.productList.innerHTML = '';
      }

      const results = queries.results;

      this.queryId = results[0].queryID;

      this.generateProductsFromHits(results[0].hits, results[0].queryID);
      this.generatePaginationFromResults(results[0]);
      this.generateCountsFromResults(results[0]);

      this.generatePillsFromFacets();

      if (fullBuild) {
        if (results.length == 1) {
          this.generateFiltersFromFacets(results[0].facets);
        } else {
          // IF the facet is applied, use that facet's data to build the filters.
          // Otherwise, use the default facets.
          const facetLocation = {};

          Object.keys(this.currentFilters).forEach((facet, index) => {
            facetLocation[facet] = index + 1;
          });

          this.generateFiltersFromResults(results, facetLocation);
        }
      }

      if (paginationTriggered) {
        // Scroll to the top of the product list
        this.productList.scrollIntoView({ behavior: 'smooth' });
      }
    });

    this.loaded = true;
  }

  /**
   * Build the index params for the algoliaShopify API. The 'index' is the algolia product list to search.
   * @returns {string} The index params.
   */
  buildIndexParams() {
    const prairies = ['AB', 'MB', 'SK'];
    const atlantic = ['QC', 'PE', 'NS', 'NB', 'NL'];
    let currentRegion;

    try {
      currentRegion = Shopify.customerPrivacy.getRegion();
    } catch (error) {
      currentRegion = 'CAON';
    }

    const countryCode = currentRegion.slice(0, 2);
    const regionCode = currentRegion.slice(-2);

    if (this.currentSortBy != '') {
      return `${algoliaShopify.config.index_prefix}products${
        window.theme.locale == 'fr_CA' ? '_canada_fr' : ''
      }${this.currentSortBy}`;
    } else if (prairies.includes(regionCode)) {
      return `${algoliaShopify.config.index_prefix}products${
        window.theme.locale == 'fr_CA' ? '_canada_fr' : ''
      }_Prairies`;
    } else if (atlantic.includes(regionCode)) {
      return `${algoliaShopify.config.index_prefix}products${
        window.theme.locale == 'fr_CA' ? '_canada_fr' : ''
      }_QC_Atlantic`;
    } else if (regionCode == 'BC') {
      return `${algoliaShopify.config.index_prefix}products${
        window.theme.locale == 'fr_CA' ? '_canada_fr' : ''
      }_BC`;
    } else {
      return `${algoliaShopify.config.index_prefix}products${
        window.theme.locale == 'fr_CA' ? '_canada_fr' : ''
      }`;
    }
  }

  buildSearchQuery() {
    if (this.searchTerms) {
      return this.searchTerms;
    }

    return '';
  }

  /**
   * Build the search params for the algoliaShopify API.
   * @returns {object} The search params.
   */
  buildSearchParams() {
    const facetParams = this.buildFacetParams();

    const context = [];

    if (this.dataset.collectionHandle && facetParams.length == 0) {
      if (algoliaShopify.config.collection_id_query_rules) {
        context.push(`${this.dataset.collectionId}`);
      } else {
        context.push(`${this.dataset.collectionHandle}`);
      }
    }

    const params = {
      page: this.currentPage,
      hitsPerPage: this.hitsPerPage,

      // Context, controls wether rules should be applied
      ruleContexts: context,

      // Returns the facet data. This is used to build the filters DOM.
      facets: this.facetFilters,
      sortFacetValuesBy: 'alpha',

      // Filters to be used for the search
      filters: this.buildFilterParams(),
      facetFilters: facetParams, // By default, we want to just apply the filters that are applied to the DOM.

      // List of product attributes to be returned
      attributesToRetrieve: ['*'],

      // Hard coded params
      distinct: true,
      clickAnalytics: true,
      enablePersonalization: false,
      userToken: getAlgoliaUserToken(),
      analyticsTags: this.analyticsTags,
    };

    return params;
  }

  /**
   * Build the multiple search params for the algoliaShopify API.
   * @returns {object} The multiple search params.
   */
  buildMultipleSearchParams() {
    const queries = [
      {
        indexName: this.buildIndexParams(),
        query: this.buildSearchQuery(),
        ...this.buildSearchParams(),
      },
    ];

    // Check if any filters are applied. If not, we can just use the default query.
    // Otherwise, we need to build a query for each facet that is applied.
    Object.keys(this.currentFilters).forEach((facet) => {
      const facetData = [];

      Object.keys(this.currentFilters).forEach((appliedFacet) => {
        if (facet !== appliedFacet) {
          const facetGroup = [];

          this.currentFilters[appliedFacet].forEach((value) => {
            facetGroup.push(`${appliedFacet}:${value}`);
          });

          facetData.push(facetGroup);
        }
      });

      queries.push({
        indexName: this.buildIndexParams(),
        query: '',
        ...this.buildSearchParams(),
        hitsPerPage: 1,
        facetFilters: facetData,
      });
    });

    return queries;
  }

  buildFilterParams() {
    // This is used to apply any filter that is not from a facet.
    // Basically, anything that does not come from a filter on the DOM.
    // This will probably not ever have anything other than the collection handle.
    const params = [];

    if (this.collectionHandle) {
      params.push(`collections:${this.collectionHandle}`);
    }

    return params.join(' AND ');
  }

  buildFacetParams() {
    // This is used to apply any filter that is from a facet.
    // A facet filter is a filter from the DOM.
    const params = [];

    Object.keys(this.currentFilters).forEach((facet) => {
      const facetGroup = [];

      this.currentFilters[facet].forEach((value) => {
        facetGroup.push(`${facet}:${value}`);
      });

      params.push(facetGroup);
    });

    return params;
  }

  /**
   * Generate the sort options from the config.
   */
  generateSortFromConfig() {
    if (this.sortBy || this.sortByDrawer) {
      this.sortData.forEach((sort) => {
        var sortOption = false;

        if (sort.asc && sort.asc.active) {
          sortOption = sort.asc;
        }

        if (sort.desc && sort.desc.active) {
          sortOption = sort.desc;
        }

        if (sortOption) {
          const option = document.createElement('option');
          option.value = `_${sort.key}_${sort.asc ? 'asc' : 'desc'}`;
          option.innerHTML = sortOption.title;

          const li = document.createElement('li');
          li.classList.add('filters__item', 'list-menu__item');

          const label = document.createElement('label');
          label.classList.add('filters__label', 'facets__label');
          label.htmlFor = `Filter_${sort.key}_${sort.asc ? 'asc' : 'desc'}`;

          const input = document.createElement('input');
          input.classList.add('mobile-facets__checkbox');
          input.type = 'radio';
          input.name = 'sort_by';
          input.value = `_${sort.key}_${sort.asc ? 'asc' : 'desc'}`;
          input.id = `Filter_${sort.key}_${sort.asc ? 'asc' : 'desc'}`;
          input.checked = this.currentSortBy == option.value;

          const span = document.createElement('span');
          span.classList.add('facet-checkbox__text-label');
          span.innerHTML = sortOption.title;

          label.appendChild(input);
          label.appendChild(span);
          li.appendChild(label);

          if (this.currentSortBy == option.value) {
            option.selected = true;
          }

          if (this.sortBy) {
            this.sortBy.appendChild(option.cloneNode(true));

            if (this.currentSortBy == option.value) {
              this.sortBy.value = option.value;
            }
          }

          if (this.sortByDrawer) {
            this.sortByDrawer.appendChild(li.cloneNode(true));
          }
        }
      });
    }
  }

  /**
   * Generate the filters from the results.
   * @param {object} results - The results from the algoliaShopify API.
   * @param {object} facetLocation - The location of the facet in the results. We do this to maintain the order of the facets.
   */
  generateFiltersFromResults(results, facetLocation) {
    const openFilterTypes = this.getOpenFilterTypes();

    if (this.filtersDesktop) {
      this.filtersDesktop.innerHTML = '';
    }

    if (this.filtersDrawer) {
      this.filtersDrawer.innerHTML = '';
    }

    this.facetData.forEach((facet, facetIndex) => {
      if (facet.enabled) {
        if (results[facetLocation[facet.name]]) {
          const facetValues =
            results[facetLocation[facet.name]].facets[facet.name];

          if (facetValues) {
            this.generateFilters(
              facet,
              facetValues,
              facetIndex,
              openFilterTypes
            );
          }
        } else {
          const facetValues = results[0].facets[facet.name];

          if (facetValues) {
            this.generateFilters(
              facet,
              facetValues,
              facetIndex,
              openFilterTypes
            );
          }
        }
      }
    });
  }

  /**
   * Generate the filters from the facets.
   * @param {object} facets - The facets from the algoliaShopify API.
   */
  generateFiltersFromFacets(facets) {
    const openFilterTypes = this.getOpenFilterTypes();

    if (this.filtersDesktop) {
      this.filtersDesktop.innerHTML = '';
    }

    if (this.filtersDrawer) {
      this.filtersDrawer.innerHTML = '';
    }

    this.facetData.forEach((facet, facetIndex) => {
      if (facet.enabled) {
        if (facets[facet.name]) {
          this.generateFilters(
            facet,
            facets[facet.name],
            facetIndex,
            openFilterTypes
          );
        }
      }
    });
  }

  /**
   * Generate the filters from the facet values.
   * @param {object} facet - The facet from the algoliaShopify API.
   * @param {object} facetValues - The facet values from the algoliaShopify API.
   * @param {number} facetIndex - The index of the facet.
   * @param {array} openFilterTypes - The open filter types.
   */
  generateFilters(facet, facetValues, facetIndex, openFilterTypes) {
    const details = document.createElement('details');
    details.id = `Filter-${this.sectionId}-${facetIndex}`;
    details.classList.add('filters__details', 'border');
    details.dataset.index = `mobile-${this.currentPage}`;

    if (openFilterTypes.includes(details.id)) {
      details.open = true;
    }

    const facetTitleId = algoliaStringify(facet.title);

    const summary = document.createElement('summary');
    summary.classList.add('filters__summary', 'h3');
    summary.innerHTML = `<span>${facet.title}</span>`;
    details.appendChild(summary);

    const div = document.createElement('div');
    div.classList.add('mobile-facets__submenu');
    details.appendChild(div);

    const ul = document.createElement('ul');
    ul.classList.add('filters__list', 'list--unstyled');
    div.appendChild(ul);

    const facetKeys = Object.keys(facetValues);

    if (facet.name == 'price_range') {
      // Sort the facet keys by the value on the left of the colon
      facetKeys.sort((a, b) => {
        const aValue = a.split(':')[0];
        const bValue = b.split(':')[0];
        return aValue - bValue;
      });
    }

    facetKeys.forEach((value, valueIndex) => {
      const li = document.createElement('li');
      li.classList.add('filters__item', 'list-menu__item');
      ul.appendChild(li);

      const label = document.createElement('label');
      label.classList.add('facets__label', 'filters__label');
      label.htmlFor = `Filter-${this.sectionId}-${facetIndex}-${valueIndex}`;
      li.appendChild(label);

      const input = document.createElement('input');
      input.classList.add('mobile-facets__checkbox');
      input.id = `Filter-${this.sectionId}-${facetIndex}-${valueIndex}`;
      input.type = 'checkbox';
      input.name = facet.name;
      input.value = value;
      input.checked =
        this.currentFilters[facet.name] &&
        this.currentFilters[facet.name].includes(value);

      const span = document.createElement('span');
      span.classList.add('facet-checkbox__text', 'facet-checkbox__text-label');

      const labelId = algoliaStringify(value);

      if (facet.name == 'named_tags.Colour') {
        ul.classList.add('filters__list--grid');

        input.classList.add('visually-hidden');
        span.classList.add('visually-hidden');

        label.classList.add('filters__label--swatch');
        label.dataset.value = value.toLowerCase();
        label.setAttribute('title', value);       

        span.innerHTML = `${value}`;
      } else if (facet.name == 'options.size') {
        ul.classList.add('filters__list--grid');

        input.classList.add('visually-hidden');

        label.classList.add('filters__label--size');
        span.innerHTML = `${value}`; // TRANSLATIONS
      } else if (facet.name == 'price_range') {
        if (value == '0:10') {
          span.innerHTML = window.language.under_10;
        } else if (value.indexOf(':') > -1) {
          const priceRange = value.split(':');
          span.innerHTML = `$${priceRange[0]} - $${priceRange[1]}`;
        } else {
          span.innerHTML = `${value}`;
        }
      } else if (facet.name == 'named_tags.Discount Amount') {
        span.innerHTML = `${(parseFloat(value) * 100).toFixed(0)}%`;
      } else {
        span.innerHTML = `${value}`; // TRANSLATIONS
      }

      label.appendChild(span);
      label.appendChild(input);
    });

    if (this.filtersDesktop) {
      const clone = details.cloneNode(true);

      clone.id = `${clone.id}-desktop`;

      clone.querySelectorAll('[id]').forEach((element) => {
        element.id = `${element.id}-desktop`;
      });

      clone.querySelectorAll('[for]').forEach((element) => {
        element.setAttribute('for', `${element.getAttribute('for')}-desktop`);
      });

      this.filtersDesktop.appendChild(clone);
    }

    if (this.filtersDrawer) {
      this.filtersDrawer.appendChild(details.cloneNode(true));
    }
  }

  /**
   * Generate the product cards from the hits.
   * @param {object} hits - The product hits from the algoliaShopify API.
   */
  generateProductsFromHits(hits, queryId) {
    const powerReviewProducts = [];

    hits.forEach((hit, index) => {
      const li = document.createElement('li');
      li.classList.add('grid__item');
      //li.dataset.cascade = true;
      //li.style.setProperty('--animation-order', `${index + this.indexAdjust}`);

      const product = document.createElement('card-component');
      product.classList.add('card', `color-${window.cards.color_scheme}`);

      product.dataset.productId = hit.id;
      product.dataset.objectId = hit.objectID;
      product.dataset.position = index + this.indexAdjust;
      product.dataset.queryId = queryId;

      // Map Algolia hit fields to Shopify Liquid equivalents
      product.dataset.id = hit.id; // data-id
      product.dataset.handle = hit.handle || ''; // data-handle
      product.dataset.url = `${
        this.collectionHandle
          ? `${window.theme.locale == 'fr_CA' ? '/fr' : ''}/collections/${
              this.collectionHandle
            }`
          : ''
      }/products/${hit.handle}`; // data-url
      product.dataset.title = hit.title || ''; // data-title
      product.dataset.vendor = hit.vendor || hit.brand || ''; // data-vendor
      product.dataset.type = hit.product_type || hit.type || ''; // data-type
      product.dataset.price =
        typeof hit.price === 'number' ? hit.price : parseFloat(hit.price) || 0; // data-price (no currency)

      const imageLink = document.createElement('a');
      imageLink.classList.add('card__link', 'link--unstyled');
      imageLink.href = `${
        this.collectionHandle
          ? `${window.theme.locale == 'fr_CA' ? '/fr' : ''}/collections/${
              this.collectionHandle
            }`
          : ''
      }/products/${hit.handle}`;
      imageLink.addEventListener('click', this.onLinkClick.bind(this));

      const imageWrapper = document.createElement('div');
      imageWrapper.classList.add('card__image-wrapper');

      if (hit.meta?.custom?.global_access) {
        product.classList.add('card--global-access');
      }

      if (
        hit.meta?.custom?.coming_soon &&
        hit.meta?.custom?.coming_soon == true
      ) {
        const badge = document.createElement('div');
        badge.classList.add('badge', 'card__price-badge', 'badge--coming-soon');
        badge.innerHTML = `
          ${window.cards.coming_soon}
        `;
        imageWrapper.appendChild(badge);
      } else if (hit.compare_at_price > hit.price) {
        const badge = document.createElement('div');
        badge.classList.add('badge', 'card__price-badge', 'badge--percent-off');
        const percentOff =
          ((hit.compare_at_price - hit.price) / hit.compare_at_price) * 100;
        badge.innerHTML = `
          ${JDRounding(percentOff)}${window.cards.percent_off}
        `;
        imageWrapper.appendChild(badge);
      }

      if (hit.meta?.custom?.custom_badges) {
        const customBadges = JSON.parse(hit.meta.custom.custom_badges);

        // Add the handleized custom badge to the class
        customBadges.forEach((customBadge, index) => {
          const customBadgeElement = document.createElement('div');
          customBadgeElement.classList.add(
            'badge',
            'card__price-badge',
            `badge--${index + 1}`,
            `badge--${handleize(customBadge)}`
          );
          customBadgeElement.innerHTML = customBadge;
          imageWrapper.appendChild(customBadgeElement);
        });
      }

      if (window.theme.wishlist_enabled && hit) {
        const wishlistContainer = document.createElement('div');
        wishlistContainer.classList.add('wishlist__button');

        const wishlistButton = document.createElement('button');
        wishlistButton.classList.add(
          'link',
          'swym__button',
          'product_' + hit.id
        );
        wishlistButton.dataset.withEpi = 'true';
        wishlistButton.dataset.swaction = 'addToWishlist';
        wishlistButton.dataset.productId = hit.id;
        wishlistButton.dataset.variantId = hit.objectID;
        wishlistButton.dataset.productUrl = `${location.origin}/products/${hit.handle}`;

        wishlistContainer.appendChild(wishlistButton);
        imageWrapper.appendChild(wishlistContainer);
      }

      const imageContainer = document.createElement('div');
      imageContainer.classList.add('card__image-container');

      let imageList = [];
      if (hit.meta?.custom?.images) {
        imageList = hit.meta.custom.images.split(',');
      } else {
        imageList = [hit.image];
      }

      const slider = document.createElement('ul');
      slider.classList.add(
        'slider',
        'grid',
        'grid--1-col',
        'slider--desktop',
        'slider--mobile'
      );
      slider.setAttribute('aria-label', 'Product Images');

      imageList.forEach((src) => {
        const li = document.createElement('li');
        li.classList.add('grid__item', 'slider__slide');

        const mediaContainer = document.createElement('div');
        mediaContainer.classList.add(
          'media',
          `media--${window.cards.aspect_ratio}`
        );

        const image = document.createElement('img');
        image.classList.add('motion-reduce');
        image.loading = 'lazy';
        image.width = 540;
        image.height = 540;
        image.src = src + '&width=540';
        image.srcset = `${src + '&width=180'} 180w, ${
          src + '&width=360'
        } 360w, ${src + '&width=540'} 540w, ${src + '&width=720'} 720w, ${
          src + '&width=900'
        } 900w, ${src + '&width=1080'} 1080w`;
        image.alt = hit.title;
        image.sizes =
          '(min-width: 750px) calc((100vw - 1rem) / 4), calc((100vw - 1rem) / 2)';

        mediaContainer.appendChild(image);
        li.appendChild(mediaContainer);
        slider.appendChild(li);
      });

      imageContainer.appendChild(slider);
      imageWrapper.appendChild(imageContainer);
      imageLink.appendChild(imageWrapper);

      const details = document.createElement('div');
      details.classList.add('card__details');

      const title = document.createElement('div');
      title.classList.add('card__title');

      const span = document.createElement('a');
      span.href = `${window.theme.locale == 'fr_CA' ? '/fr' : ''}/products/${
        hit.handle
      }`;
      span.classList.add('card__title-title', 'h4', 'link--unstyled');
      span.innerHTML = hit.title;

      title.appendChild(span);
      details.appendChild(title);

      if (hit.meta?.custom?.subtitle) {
        const subtitle = document.createElement('div');
        subtitle.classList.add('card__subtitle', 'body');
        subtitle.innerHTML = hit.meta.custom.subtitle;
        details.appendChild(subtitle);
      }

      const priceContainer = document.createElement('div');
      priceContainer.classList.add('card__price');

      const price = document.createElement('div');
      price.classList.add('price');
      if (hit.compare_at_price > hit.price) {
        price.classList.add('price--on-sale');
      }

      price.innerHTML = `
        <div class="price__sale">
          <span class="visually-hidden visually-hidden--inline">Sale Price</span>
          <span class="price-item">
            $${hit.price}
          </span>
        </div>            

        ${
          hit.compare_at_price > hit.price
            ? `
          <div class="price__regular body body--small gray">
            <span class="visually-hidden visually-hidden--inline">Regular Price</span>
            <s class="price-item">
              $${hit.compare_at_price}
            </s>
          </div>
        `
            : ''
        }
      `;

      priceContainer.appendChild(price);
      details.appendChild(priceContainer);

      if (window.theme.reviews.enabled) {
        const reviews = document.createElement('div');
        reviews.classList.add('card__reviews');
        reviews.id = `CardReview-${hit.id}`;

        details.appendChild(reviews);
      }

      if (hit.named_tags['#.Group']) {
        const cardGroup = document.createElement('card-group');
        cardGroup.classList.add('card__swatches');
        cardGroup.dataset.groupId = hit.named_tags['#.Group'];
        cardGroup.dataset.productHandle = hit.handle;
        cardGroup.dataset.productUrl = `/products/${hit.handle}`;
        cardGroup.dataset.limitSwatches = 'true';
        cardGroup.dataset.reorderSwatches = 'true';
        cardGroup.dataset.waitUntilLoaded = 'true';
        cardGroup.dataset.hardLoad = 'true';
        details.appendChild(cardGroup);

        const skeleton = document.createElement('div');
        skeleton.classList.add('skeleton');
        cardGroup.appendChild(skeleton.cloneNode(true));
        cardGroup.appendChild(skeleton.cloneNode(true));
      } else {
        const swatchesPlaceholder = document.createElement('div');
        swatchesPlaceholder.classList.add(
          'card__swatches',
          'card__swatches--placeholder'
        );
        swatchesPlaceholder.setAttribute('aria-hidden', 'true');
        details.appendChild(swatchesPlaceholder);
      }

      product.appendChild(imageLink);
      product.appendChild(details);

      if (
        window.cards.enable_quickview ||
        window.cards.enable_quickview_mobile
      ) {
        const quickviewTrigger = document.createElement('quickview-trigger');
        quickviewTrigger.classList.add('card__quickview');

        if (!window.cards.enable_quickview) {
          quickviewTrigger.classList.add('hidden--desktop');
        }

        if (!window.cards.enable_quickview_mobile) {
          quickviewTrigger.classList.add('hidden--mobile');
        }
        const root = window.Shopify?.routes?.root || '';
        
        quickviewTrigger.dataset.productHandle = hit.handle;
        quickviewTrigger.dataset.productUrl = `${window.location.origin}/${root}/products/${hit.handle}`;

        const quickviewButton = document.createElement('button');
        quickviewButton.classList.add(
          'button',
          'button--secondary',
          'button--small'
        );
        quickviewButton.innerHTML = `
          ${window.cards.quickbuy}
        `;
        quickviewTrigger.appendChild(quickviewButton);

        product.appendChild(quickviewTrigger);
      }

      li.appendChild(product);
      this.productList.appendChild(li);

      const pageTitle = (document.title || "").split(/\s[-–—]\s/)[0].trim();
      if (this.collectionPromos) {
        const promos = Shopify.locale == "fr" ? this.collectionPromos.tiles_fr : this.collectionPromos.tiles;
        const bannerData = Shopify.locale == "fr" ? this.collectionPromos.banner_fr : this.collectionPromos.banner;

        if(promos.length > 0) {
          promos.forEach((tile, tileIndex) => {
            if (
              index + this.indexAdjust == tile.position &&
              (tile.image || tile.video || tile.video_mobile)
            ) {
              const tileLi = document.createElement('li');
              tileLi.classList.add('grid__item', 'promo-tile');

              const tileMedia = document.createElement('div');
              tileMedia.classList.add('media', 'media--collection');
              if (tile.link == '' && tile.name != '') {
                tileMedia.dataset.promoTileName = tile.name;
              }

              const desktopW = Number(tile.width) || 0;
              const desktopH = Number(tile.height) || 0;
              const mobileW = Number(tile.width_mobile) || desktopW;
              const mobileH = Number(tile.height_mobile) || desktopH;
              if (desktopW > 0 && desktopH > 0) {
                tileLi.style.setProperty(
                  '--tile-aspect-desktop',
                  `${desktopW} / ${desktopH}`
                );
              }
              if (mobileW > 0 && mobileH > 0) {
                tileLi.style.setProperty(
                  '--tile-aspect-mobile',
                  `${mobileW} / ${mobileH}`
                );
              }

              /**
               * Keep imgs/videos as direct children of .media so theme rules
               * (.media > * and .media img/video) match the original layout.
               * Use hidden--mobile / hidden--desktop for art direction (see base.css).
               */
              const canPlayVideo = !prefersReducedMotion;
              const desktopVideoSrc =
                canPlayVideo && tile.video ? tile.video : null;
              const mobileVideoSrc =
                canPlayVideo && tile.video_mobile ? tile.video_mobile : null;
              const useArtDirection = Boolean(
                tile.video_mobile || tile.image_mobile
              );

              if (useArtDirection) {
                if (desktopVideoSrc) {
                  tileMedia.appendChild(
                    createPromoTileVideo({
                      src: desktopVideoSrc,
                      poster: tile.image,
                      width: tile.width,
                      height: tile.height,
                      className: 'hidden--mobile',
                    })
                  );
                } else if (tile.image) {
                  tileMedia.appendChild(
                    createPromoTileImage({
                      src: tile.image,
                      width: tile.width,
                      height: tile.height,
                      className: 'hidden--mobile',
                    })
                  );
                }

                if (mobileVideoSrc) {
                  tileMedia.appendChild(
                    createPromoTileVideo({
                      src: mobileVideoSrc,
                      poster: tile.image_mobile || tile.image,
                      width: tile.width_mobile || tile.width,
                      height: tile.height_mobile || tile.height,
                      className: 'hidden--desktop',
                    })
                  );
                } else if (tile.image_mobile || tile.image) {
                  tileMedia.appendChild(
                    createPromoTileImage({
                      src: tile.image_mobile || tile.image,
                      width: tile.width_mobile || tile.width,
                      height: tile.height_mobile || tile.height,
                      className: 'hidden--desktop',
                    })
                  );
                }
              } else if (desktopVideoSrc || mobileVideoSrc) {
                tileMedia.appendChild(
                  createPromoTileVideo({
                    src: desktopVideoSrc || mobileVideoSrc,
                    poster: tile.image,
                    width: tile.width,
                    height: tile.height,
                  })
                );
              } else if (tile.image) {
                tileMedia.appendChild(
                  createPromoTileImage({
                    src: tile.image,
                    width: tile.width,
                    height: tile.height,
                  })
                );
              }

              const ctaLabel =
                tile.cta_label && String(tile.cta_label).trim();

              // Media is clickable when a link is set; CTA button below when label + link are set
              if (tile.link != '') {
                const mediaLink = document.createElement('a');
                mediaLink.href = tile.link;
                mediaLink.classList.add(
                  'link',
                  'link--unstyled',
                  'media',
                  'media--collection',
                  'promo-tile__media-link'
                );
                mediaLink.ariaLabel = tile.title || ctaLabel || tile.name || '';
                if (tile.name != '') {
                  mediaLink.dataset.promoTileName = tile.name;
                  mediaLink.dataset.internalPromotionName =
                    'Promo Card - ' + tile.name;
                  mediaLink.dataset.internalPromotionId =
                    'Promo Card - ' + tile.name;
                  mediaLink.dataset.internalCreativeName =
                    tile.video || tile.image;
                  mediaLink.dataset.internalCreativeSlot =
                    pageTitle + ' - Promo Card';
                }
                mediaLink.appendChild(tileMedia);
                tileLi.appendChild(mediaLink);
              } else {
                tileLi.appendChild(tileMedia);
              }

              if (tile.link != '' && ctaLabel) {
                const cta = document.createElement('a');
                cta.href = tile.link;
                const isPrimary =
                  String(tile.cta_type || '')
                    .trim()
                    .toLowerCase() === 'primary button';
                cta.classList.add('button', 'button--small', 'promo-tile__cta');
                if (!isPrimary) {
                  cta.classList.add('button--secondary');
                }
                cta.textContent = ctaLabel;
                if (tile.name != '') {
                  cta.dataset.promoTileName = tile.name;
                  cta.dataset.internalPromotionName =
                    'Promo Card - ' + tile.name;
                  cta.dataset.internalPromotionId =
                    'Promo Card - ' + tile.name;
                  cta.dataset.internalCreativeName =
                    tile.video || tile.image;
                  cta.dataset.internalCreativeSlot =
                    pageTitle + ' - Promo Card';
                }
                tileLi.appendChild(cta);
              }

              this.productList.appendChild(tileLi);
              this.indexAdjust++;
            }
          });
          observePromoLoopVideos(this);
        }

        if (
          index + this.indexAdjust == 7 &&
          bannerData.image &&
          Number(bannerData.width) > 0 &&
          Number(bannerData.height) > 0
        ) {
          const banner = document.createElement('div');
          banner.classList.add('listing__banner');
          banner.innerHTML = `
          <a href="${bannerData.link}"
   class="link link--unstyled listing__banner-link" ${
            bannerData.promo_banner_name
              ? `
   data-internal-creative-name="${bannerData.image}"
   data-internal-creative-slot="${pageTitle} - Mid Banner"
   data-internal-promotion-id="Mid Banner - ${bannerData.promo_banner_name}"
   data-internal-promotion-name="Mid Banner - ${bannerData.promo_banner_name}"` : ""
          }>

            <div class='media media--adapt' style='padding-bottom: ${
              (bannerData.height /
                bannerData.width) *
              100
            }%;'>
              <img src="${bannerData.image}" alt="${
            bannerData.title || ''
          }" class="listing__banner-image">
            </div>
          </a>
        `;

          this.productList.appendChild(banner);
        }
      }

      const cardGroup = li.querySelector('card-group');
      if (cardGroup) {
        cardGroup.setup();
      }

      powerReviewProducts.push({
        api_key: window.theme.reviews.api_key,
        locale: window.theme.reviews.locale,
        merchant_group_id: window.theme.reviews.group_id,
        merchant_id: window.theme.reviews.merchant_id,
        page_id: hit.id,
        components: {
          CategorySnippet: `CardReview-${hit.id}`,
        },
      });
    });

    this.indexAdjust += hits.length;

    if (window.theme.wishlist_enabled) {
      document.dispatchEvent(new CustomEvent('swym:collections-loaded'));
    }

    if (window.theme.reviews.enabled) {
      setTimeout(() => {
        pwr('render', powerReviewProducts);
      }, 150);
    }
  }

  generateCountsFromResults(results) {
    this.itemCounts.forEach((count) => {
      count.innerHTML = `(${results.nbHits} ${window.paginationStrings.items})`;
    });
  }

  /**
   * Generate the pagination from the results.
   * @param {object} results - The results from the algoliaShopify API.
   */
  generatePaginationFromResults(results) {
    if (results.nbPages == 0) {
      this.paginationContainer.remove();
      return;
    }

    /*
    this.paginationContainer.dataset.hasMore =
      results.page + 1 != results.nbPages;

    this.paginationContainer.style.setProperty(
      '--fill',
      `${
        ((results.page * results.hitsPerPage + results.hits.length) /
          results.nbHits) *
        100
      }%`
    );
    */

    const ofText = this.paginationContainer.querySelector('.pagination__of');
    const select = this.paginationContainer.querySelector(
      '.pagination__select'
    );
    const prevButton = this.paginationContainer.querySelector(
      '.pagination__button--prev'
    );
    const nextButton = this.paginationContainer.querySelector(
      '.pagination__button--next'
    );

    if (results.page == 0) {
      prevButton.disabled = true;
    } else {
      prevButton.disabled = false;
    }

    if (results.page == results.nbPages - 1) {
      nextButton.disabled = true;
    } else {
      nextButton.disabled = false;
    }

    ofText.innerHTML = window.paginationStrings.of.replace(
      '{{ number }}',
      results.nbPages
    );

    // Populate the select with options for each page
    select.innerHTML = '';
    for (let i = 0; i < results.nbPages; i++) {
      const option = document.createElement('option');
      option.value = i;
      option.innerHTML = i + 1;
      select.appendChild(option);

      if (i == results.page) {
        option.selected = true;
      }
    }

    /*
    this.paginationContainer.querySelector('.pagination__text').innerHTML =
      window.paginationStrings.viewed
        .replace(
          '{{ number }}',
          results.page * results.hitsPerPage + results.hits.length
        )
        .replace('{{ total }}', results.nbHits);

    if (results.page != results.nbPages) {
      this.paginationContainer.querySelector(
        '.pagination__more button'
      ).innerHTML = window.paginationStrings.show_more.replace(
        '{{ number }}',
        results.hitsPerPage
      );
    }
    */
  }

  generatePillsFromFacets() {
    this.pillsContainer.innerHTML = '';
this.cleanEmptyFilters();

if (!Object.keys(this.currentFilters).length) {
  this.pillsContainer.innerHTML = "";
  return;
}
    Object.keys(this.currentFilters).forEach((filterGroup) => {
      this.currentFilters[filterGroup].forEach((filter) => {
        const pill = document.createElement('button');
        pill.classList.add('filters__pill');
        pill.dataset.filterGroup = filterGroup;
        pill.dataset.filter = filter;

        // price - use textContent to prevent XSS from URL parameters
        if (filterGroup == 'price_range') {
          const parts = filter.split(':');
          pill.textContent = `$${parts[0]} - $${parts[1]}`;
        } else {
          pill.textContent = filter;
        }

        const span = document.createElement('span');
        span.classList.add('visually-hidden');
        span.textContent = `Remove filter: ${filter}`;

        pill.appendChild(span);

        pill.addEventListener('click', this.onFilterPillClick.bind(this));

        this.pillsContainer.appendChild(pill);
      });
    });

    if (Object.keys(this.currentFilters).length != 0) {
      const pill = document.createElement('a');
      pill.classList.add('link', 'link--underlined', 'filters__pill--clear');
      pill.href = `${window.location.pathname}`;
      pill.textContent = window.language.clear_all;

      const span = document.createElement('span');
      span.classList.add('visually-hidden');
      span.textContent = 'Remove all filters';

      pill.appendChild(span);

      this.pillsContainer.appendChild(pill);
    }
  }

  /**
   * Get the open filter types. This is used to maintain the open/closed state of the filters.
   * @returns {array} The open filter types.
   */
  getOpenFilterTypes() {
    const openFiltersDesktop = [];
    const openFiltersDrawer = [];

    if (this.filtersDesktop) {
      this.filtersDesktop.querySelectorAll('details').forEach((details) => {
        if (details.open) {
          openFiltersDesktop.push(details.id);
        }
      });
    }

    if (this.filtersDrawer) {
      this.filtersDrawer.querySelectorAll('details').forEach((details) => {
        if (details.open) {
          openFiltersDrawer.push(details.id);
        }
      });
    }

    return openFiltersDesktop.concat(openFiltersDrawer);
  }
  cleanEmptyFilters() {
    Object.keys(this.currentFilters).forEach((key) => {
      if (
        !this.currentFilters[key] ||
        this.currentFilters[key].length === 0
      ) {
        delete this.currentFilters[key];
      }
    });
  }

  onFilterPillClick(event) {
    const target = event.target.closest("[data-filter-group]");
    if (!target) return;

    const filterGroup = target.dataset.filterGroup;
    const filter = target.dataset.filter;

    const input = this.querySelector(
      `input[name="${filterGroup}"][value="${CSS.escape(filter)}"]`,
    );

    if (input) {
      input.checked = false;
      this.onFilterChange(input);
      return;
    }
    if (this.currentFilters[filterGroup]) {
      this.currentFilters[filterGroup] = this.currentFilters[
        filterGroup
      ].filter((v) => v !== filter);

      if (this.currentFilters[filterGroup].length === 0) {
        delete this.currentFilters[filterGroup];
      }
    }

    const url = new URL(window.location.href);
    const params = url.searchParams;

    const values = params.getAll(filterGroup);

    if (values.length) {
      const newValues = values.filter((v) => v !== filter);

      params.delete(filterGroup);
      newValues.forEach((v) => params.append(filterGroup, v));
    }

    window.history.replaceState({}, "", url.pathname + "?" + params.toString());

    this.search();
  }

  /**
   * Handle the filter change.
   * @param {object} event - The event object.
   */
  onFilterChange(event) {
    var target = event;

    if (event.target) {
      target = event.target;
    }

    const form = target.closest('form');

    const name = target.name;
    const value = target.value;

    if (!this.currentFilters[name]) {
      this.currentFilters[name] = [];
    }

    if (target.checked) {
      this.currentFilters[name].push(value);

      if (window.theme.dynamic_yield_enabled && DynamicYield) {
        DynamicYield.filterItems(target.name, target.value);

        if (aa) {
          aa('clickedFilters', {
            userToken: getAlgoliaUserToken(),
            index: this.buildIndexParams(),
            eventName: 'PLP: Filter Clicked',
            filters: [`${target.name}:${target.value}`],
          });
        }
      }
    } else {
      this.currentFilters[name] = this.currentFilters[name].filter(
        (item) => item !== value
      );
    }

    if (form == this.filtersDesktop) {
      const siblingInput = this.filtersDrawer.querySelector(
        `input[name="${target.name}"][value="${target.value}"]`
      );

      if (siblingInput) {
        siblingInput.checked = target.checked;
      }
    }

    if (this.filtersDesktop && form == this.filtersDrawer) {
      const siblingInput = this.filtersDesktop.querySelector(
        `input[name="${target.name}"][value="${target.value}"]`
      );

      if (siblingInput) {
        siblingInput.checked = target.checked;
      }
    }

    this.updateURLHash();
    this.search();
  }

  /**
   * Handle the sort change.
   * @param {object} event - The event object.
   */
  onSortChange(event) {
    this.currentSortBy = event.target.value;

    if (event.target.id == 'AlgoliaDrawerSortBy') {
      this.sortBy.value = event.target.value;
    } else {
      this.sortByDrawer.querySelectorAll('input').forEach((input) => {
        if (input.value == event.target.value) {
          input.checked = true;
        } else {
          input.checked = false;
        }
      });
    }

    if (window.theme.dynamic_yield_enabled && DynamicYield) {
      const order =
        event.target.value.split('_').pop() === 'asc' ? 'asc' : 'desc';
      DynamicYield.sortItems(event.target.value, order);
    }

    this.updateURLHash();
    this.search();
  }

  /**
   * Handle the pagination events.
   * @param {object} event - The event object.
   */
  onPaginationClick(event) {
    this.currentPage++;
    this.search(false);
  }

  onPaginationSelect(event) {
    this.currentPage = event.target.value;

    this.updateURLHash();

    this.search(false, true);
  }

  onPaginationPrev(event) {
    this.currentPage--;

    this.updateURLHash();

    this.search(false, true);
  }

  onPaginationNext(event) {
    this.currentPage++;

    this.updateURLHash();

    this.search(false, true);
  }

  onLinkClick(event) {
    const card = event.target.closest('.card');

    const position = parseInt(card.dataset.position) + 1;
    
    aa('clickedObjectIDsAfterSearch', {
      userToken: getAlgoliaUserToken(),
      eventName: 'PLP: Search Result Clicked',
      index: this.buildIndexParams(),
      queryID: card.dataset.queryId,
      objectIDs: [card.dataset.objectId],
      positions: [position],
    });

    addToAlgoliaStorage(card.dataset.productId, card.dataset.queryId, this.buildIndexParams());
  }

  /**
   * Update the URL hash.
   */
  updateURLHash() {
  const params = new URLSearchParams();

  if (this.searchTerms) {
    params.set('q', this.searchTerms);
  }
this.cleanEmptyFilters();

  Object.keys(this.currentFilters).forEach((filter) => {
    this.currentFilters[filter].forEach((value) => {
      params.append(filter, value);
    });
  });

  if (this.currentSortBy) {
    params.set('sort_by', this.currentSortBy);
  }

  if (this.currentPage !== 0) {
    params.set('page', this.currentPage);
  }

  const queryString = params.toString();
  const newUrl = queryString
    ? `${window.location.pathname}?${queryString}`
    : window.location.pathname;

  history.pushState(
    {
      page: this.currentPage,
      searchParams: this.currentFilters,
      sortBy: this.currentSortBy,
    },
    '',
    newUrl
  );
}

}

customElements.define('listing-algolia', ListingAlgolia);

class ListingComponent extends HTMLElement {
  constructor() {
    super();

    this.filterIds = ['FiltersForm', 'FiltersFormDrawer'];

    this.template = this.dataset.template;
    this.sectionId = this.dataset.sectionId;
    this.cache = [];

    this.initialSearchParams = window.location.search.slice(1);
    this.currentSearchParams = window.location.search.slice(1);

    this.hasFilters = false;

    this.forms = this.querySelectorAll('listing-form form');

    this.debouncedOnSubmit = debounce((event) => {
      this.onSubmitHandler(event);
    }, 800);

    this.forms.forEach((form) => {
      form.addEventListener('input', this.debouncedOnSubmit.bind(this));

      if (this.filterIds.indexOf(form.id) > -1) {
        this.hasFilters = true;
      }
    });

    window.addEventListener('popstate', (event) => {
      const searchParams = event.state
        ? event.state.searchParams
        : this.initialSearchParams;

      if (searchParams === this.currentSearchParams) return;

      this.renderPage(searchParams, null, false);
    });
  }

  onSubmitHandler(event) {
    event.preventDefault();

    const forms = [];

    this.forms.forEach((form) => {
      if (this.filterIds.indexOf(form.id) > -1) {
        if (form.contains(event.target)) {
          forms.push(this.createSearchParams(form));
        }
      } else {
        forms.push(this.createSearchParams(form));
      }
    });

    this.renderPage(forms.join('&'), event);
  }

  createSearchParams(form) {
    const formData = new FormData(form);

    const priceRangeEntries = Array.from(formData.entries()).filter(([key]) =>
      key.startsWith('price_range')
    );

    if (priceRangeEntries.length > 0) {
      var priceMin = 99999999;
      var priceMax = 0;

      priceRangeEntries.forEach(([key, value]) => {
        const [min, max] = value.split('-');

        if (min < priceMin) {
          priceMin = min;
        }

        if (max > priceMax) {
          priceMax = max;
        }
      });

      formData.append(`filter.v.price.gte`, (priceMin / 100).toFixed(2));

      formData.append(`filter.v.price.lte`, (priceMax / 100).toFixed(2));

      formData.delete('price_range');
    }

    return new URLSearchParams(formData).toString();
  }

  renderPage(searchParams, event, updateURLHash = true) {
    this.currentSearchParams = searchParams;

    this.classList.add('loading');

    const url = `${window.location.pathname}?section_id=${this.sectionId}&${searchParams}`;

    this.cache.some((element) => element.url === url)
      ? this.renderSectionFromCache(url, event)
      : this.renderSectionFromFetch(url, event);

    if (updateURLHash) this.updateURLHash(searchParams);
  }

  renderSectionFromFetch(url, event) {
    fetch(url)
      .then((response) => response.text())
      .then((responseText) => {
        const html = responseText;

        this.buildPage(url, html, event);
      });
  }

  renderSectionFromCache(url, event) {
    const html = this.cache.find((element) => element.url === url).html;

    this.buildPage(url, html, event);
  }

  updateURLHash(searchParams) {
    history.pushState(
      { searchParams },
      '',
      `${window.location.pathname}${searchParams && '?'.concat(searchParams)}`
    );
  }

  buildPage(url, html, event) {
    this.cache.push({ html, url });

    if (this.hasFilters) {
      this.buildFilters(html, event);
    }

    this.buildProducts(html, event);

    this.classList.remove('loading');
  }

  buildFilters(html, event) {
    const parsedHTML = new DOMParser().parseFromString(html, 'text/html');

    this.filterIds.forEach((filterId) => {
      const filterFromFetch = parsedHTML.getElementById(filterId);
      const filterFromDom = document.getElementById(filterId);

      if (!filterFromFetch) return;
      if (!filterFromDom) return;

      const detailsFromFetch = parsedHTML.querySelectorAll(
        `#${filterId} details`
      );
      const detailsFromDom = document.querySelectorAll(`#${filterId} details`);

      var openDetails = [];
      var closedDetails = [];

      detailsFromDom.forEach((detail) => {
        if (detail.open) {
          openDetails.push(detail.id);
        } else {
          closedDetails.push(detail.id);
        }
      });

      detailsFromFetch.forEach((detail) => {
        if (openDetails.indexOf(detail.id) > -1) {
          detail.open = true;
        } else {
          detail.open = false;
        }
      });

      filterFromDom.innerHTML = filterFromFetch.innerHTML;
    });

    if (event) {
      const selectedInput = document.querySelector(`#${event.target.id}`);

      if (selectedInput) {
        selectedInput.focus();
      }
    }
  }

  buildProducts(html, event) {
    const parsedHTML = new DOMParser().parseFromString(html, 'text/html');

    document.getElementById('ProductGridContainer').innerHTML =
      parsedHTML.getElementById('ProductGridContainer').innerHTML;

    document
      .getElementById('ProductGridContainer')
      .querySelectorAll('.scroll-trigger')
      .forEach((element) => {
        element.classList.remove('scroll-trigger');
        element.classList.remove('animate--slide-in');
      });
  }
}

customElements.define('listing-component', ListingComponent);

class PriceRange extends HTMLElement {
  constructor() {
    super();
    this.querySelectorAll('input').forEach((element) => {
      element.addEventListener('change', this.onRangeChange.bind(this));
      element.addEventListener('keydown', this.onKeyDown.bind(this));
    });
    this.setMinAndMaxValues();
  }

  onRangeChange(event) {
    this.adjustToValidValues(event.currentTarget);
    this.setMinAndMaxValues();
  }

  onKeyDown(event) {
    if (event.metaKey) return;

    const pattern =
      /[0-9]|\.|,|'| |Tab|Backspace|Enter|ArrowUp|ArrowDown|ArrowLeft|ArrowRight|Delete|Escape/;
    if (!event.key.match(pattern)) event.preventDefault();
  }

  setMinAndMaxValues() {
    const inputs = this.querySelectorAll('input');
    const minInput = inputs[0];
    const maxInput = inputs[1];
    if (maxInput.value) minInput.setAttribute('data-max', maxInput.value);
    if (minInput.value) maxInput.setAttribute('data-min', minInput.value);
    if (minInput.value === '') maxInput.setAttribute('data-min', 0);
    if (maxInput.value === '')
      minInput.setAttribute('data-max', maxInput.getAttribute('data-max'));
  }

  adjustToValidValues(input) {
    const value = Number(input.value);
    const min = Number(input.getAttribute('data-min'));
    const max = Number(input.getAttribute('data-max'));

    if (value < min) input.value = min;
    if (value > max) input.value = max;
  }
}

customElements.define('price-range', PriceRange);

class LoadMore extends HTMLElement {
  constructor() {
    super();

    this.params = this.dataset.params;

    this.listing = this.closest('listing-component');

    this.button = this.querySelector('.pagination__more');

    this.button.addEventListener('click', this.onButtonClick.bind(this));
  }

  onButtonClick() {
    this.listing.renderPage(this.params, null, false);
  }
}

customElements.define('load-more', LoadMore);
